import React, { useEffect, useState } from "react";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Sidebar } from "./Sidebar";
import { Header } from "./Header";
import { Footer } from "./Footer";
import Banner from "./components/Banner";
import SliderContainer from "./components/SliderContainer";

const CookiePolicy = () => {
  const [isSidebar, setSidebar] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
    const handleResize = () => {
      if (window.innerWidth > 991) {
        setSidebar(true);
      } else {
        setSidebar(false);
      }
    };

    // Add event listener for resize
    window.addEventListener("resize", handleResize);

    // Initial check to set the correct sidebar state
    handleResize();

    // Cleanup the event listener on component unmount
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <app-root _nghost-jrx-c101="" ng-version="12.2.16">
      <div _ngcontent-jrx-c101="">
        <app-landing-page-new _nghost-jrx-c95="" className="ng-star-inserted">
          <div _ngcontent-jrx-c95="" className="head-container">
            <div _ngcontent-jrx-c95="" className="body-container">
              <Sidebar isSidebar={isSidebar} />
              <div
                _ngcontent-jrx-c95=""
                className={`rightbar`}
                style={{
                  width: isSidebar ? "" : "100%",
                  transition: "width 0.3s ease-in-out",
                }}
              >
                <Header isSidebar={isSidebar} setSidebar={setSidebar} />

                <Banner />

                <div _ngcontent-ulj-c108 className="router-outlet mx-3 fs-16">
                  <router-outlet _ngcontent-ulj-c108 />
                  <app-terms-and-condiitons className="ng-star-inserted">
                    <div
                      className="main-wrapper ng-star-inserted"
                      style={{
                        maxWidth: "1000px !important",
                        marginBottom: 100,
                      }}
                    >
                      <div className="modal-header">
                        <h4 className="modal-title fw-bold fs-16 mb-4 cookiepolicy-header">
                          Cookie Policy
                        </h4>
                      </div>
                      <div className="modal-content sm-fs-13">
                        <div id="cookiepolicy">
                          <p>
                            Exchange’s websites (including those optimized for
                            mobile devices) and mobile applications use cookies
                            and similar technologies to manage login sessions,
                            provide personalized web pages and to tailor
                            advertising and other content to reflect your
                            specific needs and interests. By using Exchange’s
                            website and applications you agree to the use of
                            cookies and similar technologies for the purposes we
                            describe in this policy.
                          </p>
                          <p>
                            <a>
                              <strong> What is a web cookie? </strong>
                            </a>
                          </p>
                          <p>
                            {" "}
                            Cookies are text files containing a small amount of
                            information that are downloaded to your device when
                            you visit a website. They are generally used by most
                            websites to improve your online experience and to
                            ensure that content and functions are delivered and
                            used more effectively.{" "}
                          </p>
                          <p>
                            {" "}
                            Cookies perform various different functions. For
                            example, some cookies are downloaded to your device
                            temporarily for the period that you browse a
                            particular website; these cookies might allow you to
                            navigate between pages more efficiently or enable
                            websites to remember the preferences you select.
                            Other cookies can be used to help websites remember
                            you as a returning visitor or ensure the online
                            adverts you receive are more relevant to your
                            specific needs and interests.{" "}
                          </p>
                          <p>
                            {" "}
                            You can amend your browser settings to block some or
                            all cookies. To do this, follow the instructions
                            provided by your browser manufacturer. However,{" "}
                            <b>
                              if you block cookies from Exchange’s website some
                              or all the website's functions may not perform as
                              intended. For example, you may not actually be
                              able to place any bets
                            </b>
                            .{" "}
                          </p>
                          <hr />
                        </div>
                      </div>
                    </div>
                  </app-terms-and-condiitons>
                </div>

                <Footer />
              </div>
            </div>
          </div>
        </app-landing-page-new>
      </div>
    </app-root>
  );
};

export default CookiePolicy;
